module.exports = __webpack_public_path__ + "static/img/gold_one.ea6f766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gold_one.png
// module id = dz12
// module chunks = 1